var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9823 1.52563C17.1448 0.508278 16.1584 -0.295281 15.2383 0.104843L0.775771 6.39419C-0.232716 6.83268 -0.284391 8.33842 0.77649 8.79264C1.56141 9.12868 2.76269 9.62142 3.96747 10.0317C4.9557 10.3682 6.033 10.6805 6.89603 10.7689C7.13231 11.0609 7.42967 11.3413 7.73177 11.5978C8.1944 11.9908 8.75149 12.3962 9.32652 12.7843C10.4781 13.5614 11.7558 14.305 12.6171 14.7882C13.6463 15.3656 14.8783 14.7007 15.0634 13.5421L16.9823 1.52563ZM2.39776 7.58433L15.1887 2.02196L13.3976 13.238C12.5531 12.7637 11.3358 12.0533 10.2518 11.3219C9.70338 10.9517 9.20253 10.5852 8.80613 10.2485C8.66497 10.1286 8.54547 10.0194 8.44592 9.92164L11.796 6.46153C12.1263 6.12043 12.1263 5.56733 11.796 5.22623C11.4658 4.8851 10.9302 4.8851 10.6 5.22623L6.9309 9.01565C6.31059 8.93371 5.44587 8.6956 4.49711 8.37258C3.76696 8.12389 3.03283 7.84149 2.39776 7.58433Z",
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.93118a455a9e4bac48ec29498721e72f.svg";
export { ForwardRef as ReactComponent };